import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  viewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../../core/services/address/address-type/address-type.service'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { ViaCepService } from '../../../../core/services/address/via-cep/via-cep.service'
import { AddressService } from '../../../../core/services/address/address/address.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'
import { IntegerInputDirective } from '../../../../shared/directives/IntegerInput'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { MatIcon } from '@angular/material/icon'
import { MatDialog } from '@angular/material/dialog'
import { convertCurrency } from '../../../../shared/utils/utils'
import moment from 'moment/moment'
import { ModalServiceAdditionalComponent } from '../../modal-service-additional/modal-service-additional.component'
import { ServiceAdditionalProposalService } from '../../../../core/services/service/service-additional-proposal/service-additional-proposal.service'

@Component({
  selector: 'service-additional-proposal-form-edit',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatSlideToggle,
    CurrencyInputDirective,
    IntegerInputDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './service-additional-proposal-form-edit.component.html',
  styleUrl: './service-additional-proposal-form-edit.component.scss',
  providers: [],
  standalone: true,
})
export class ServiceAdditionalProposalFormEditComponent
  implements OnInit, OnChanges
{
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private serviceAdditionalProposalService: ServiceAdditionalProposalService,
    private dialog: MatDialog,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false
  serviceAdditionalSelected: any = {}

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() idProposal: number = -1
  // @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  datepicker = viewChild<MatDatepicker<any>>('date')

  listType: any[] = []

  maxDate!: Date

  ngOnInit(): void {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.form.reset()
      this.fillForm()
    }
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.edit) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.serviceAdditionalSelected = {
      id: this.editItem.data.servicoAdicionalId,
    }

    this.form.get('amount')?.setValue(this.editItem.data.quantidade)
    this.form
      .get('tax')
      ?.setValue(
        typeof this.editItem.data.taxa == 'number'
          ? convertCurrency(this.editItem.data.taxa)
          : this.editItem.data.taxa,
      )
    this.form
      .get('priceUnit')
      ?.setValue(
        typeof this.editItem.data.valorUnitario == 'number'
          ? convertCurrency(this.editItem.data.valorUnitario)
          : this.editItem.data.valorUnitario,
      )
    this.form
      .get('date')
      ?.setValue(moment(this.editItem.data.dataServico, 'DD/MM/YYYY').toDate())

    this.form
      .get('priceTotal')
      ?.setValue(
        typeof this.editItem.data.valorTotal == 'number'
          ? convertCurrency(this.editItem.data.valorTotal)
          : this.editItem.data.valorTotal,
      )

    this.form.get('serviceAdditional')?.setValue(this.editItem.data.descricao)
    this.form
      .get('serviceAdditionalPrice')
      ?.setValue(
        typeof this.editItem.data.valorOriginal == 'number'
          ? convertCurrency(this.editItem.data.valorOriginal)
          : this.editItem.data.valorOriginal,
      )
  }

  resetForm() {
    // this.form.reset()
    this.serviceAdditionalSelected = {}
    this.createForm()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      serviceAdditional: ['', [Validators.required]],
      serviceAdditionalPrice: ['', [Validators.required]],
      amount: [1, [Validators.required]],
      priceUnit: ['', [Validators.required]],
      date: ['', [Validators.required]],
      priceTotal: ['', [Validators.required]],
      tax: ['5,00'],
    })
    this.form.get('priceTotal')?.disable()
    this.form.get('serviceAdditionalPrice')?.disable()
  }

  createAddress() {
    this.loading = true
    const model = this.createModel()
    this.serviceAdditionalProposalService
      .createServiceAdditionalProposal(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.response.emit({ refresh: true, clear: true })
          this.resetForm()
          this.loading = false
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  editAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.serviceAdditionalProposalService
      .editServiceAdditionalProposal(model)
      .subscribe({
        next: (response: any) => {
          this.snackbar.success(response.message)
          this.response.emit({ refresh: true, clear: true })
          this.resetForm()
          this.loading = false
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
  }

  deleteAddress() {
    this.loading = true
    const model = this.createModel(true)
    this.response.emit({ action: 'delete', item: model })
    this.resetForm()
    this.loading = false
  }

  cancel() {
    this.serviceAdditionalSelected = {}
    this.response.emit({ refresh: false, clear: true })
    this.resetForm()
  }

  createModel(edit: boolean = false) {
    let valorUnitario =
      typeof this.form.controls['priceUnit'].value == 'string'
        ? convertCurrency(this.form.controls['priceUnit'].value)
        : this.form.controls['priceUnit'].value

    let valorTotal =
      typeof this.form.controls['priceTotal'].value == 'string'
        ? convertCurrency(this.form.controls['priceTotal'].value)
        : this.form.controls['priceTotal'].value
    console.log('tax', this.form.controls['tax'].value)

    if (edit) {
      return {
        id: this.editItem.data.id,
        propostaId: this.idProposal,
        dataServico: moment(this.form.get('date')!.value).format('DD/MM/YYYY'),
        servicoAdicionalId: this.serviceAdditionalSelected.id,
        quantidade: this.form.controls['amount'].value,
        valorUnitario: valorUnitario,
        taxa:
          this.form.controls['tax'].value != ''
            ? parseFloat(
                this.form.controls['tax'].value
                  .replaceAll('.', '')
                  .replaceAll(',', '.'),
              )
            : 0,
        valorTotal: valorTotal,
      }
    } else {
      return {
        propostaId: this.idProposal,
        dataServico: moment(this.form.get('date')!.value).format('DD/MM/YYYY'),
        servicoAdicionalId: this.serviceAdditionalSelected.id,
        quantidade: this.form.controls['amount'].value,
        valorUnitario: valorUnitario,
        taxa:
          this.form.controls['tax'].value != ''
            ? parseFloat(
                this.form.controls['tax'].value
                  .replaceAll('.', '')
                  .replaceAll(',', '.'),
              )
            : 0,
        valorTotal: valorTotal,
      }
    }
  }

  openDatepicker() {
    this.datepicker()?.open()
  }

  calculateTotal() {
    //   let priceUnit =
    //     typeof this.form.controls['priceUnit'].value == 'string'
    //       ? convertCurrency(this.form.controls['priceUnit'].value)
    //       : this.form.controls['priceUnit'].value
    //   let amount =
    //     typeof this.form.controls['amount'].value == 'string'
    //       ? convertCurrency(this.form.controls['amount'].value)
    //       : this.form.controls['amount'].value
    //
    //   this.form.get('priceTotal')?.setValue(convertCurrency(priceUnit * amount))

    let priceUnit =
      typeof this.form.controls['priceUnit'].value == 'string'
        ? convertCurrency(this.form.controls['priceUnit'].value)
        : this.form.controls['priceUnit'].value
    let amount =
      typeof this.form.controls['amount'].value == 'string'
        ? convertCurrency(this.form.controls['amount'].value)
        : this.form.controls['amount'].value

    let tax =
      typeof this.form.controls['tax'].value == 'string'
        ? convertCurrency(this.form.controls['tax'].value)
        : this.form.controls['tax'].value

    let total = priceUnit * amount * (1 + tax / 100)

    total = Math.ceil(!isFinite(total) ? 0 : (total ?? 0))

    if (isNaN(total)) {
      this.form.get('priceTotal')?.setValue(convertCurrency(0))
    } else {
      this.form.get('priceTotal')?.setValue(convertCurrency(total))
    }
    // this.form.get('priceTotal')?.setValue(convertCurrency(total))
  }

  addAdditionalService() {
    const dialogRef = this.dialog.open(ModalServiceAdditionalComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        multiSelect: false,
        item: this.serviceAdditionalSelected,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.serviceAdditionalSelected.id) {
            this.serviceAdditionalSelected = response.selection
            console.log('desc: ', response)
            this.form
              .get('serviceAdditional')
              ?.setValue(this.serviceAdditionalSelected.descricao)
            this.form
              .get('serviceAdditionalPrice')
              ?.setValue(convertCurrency(this.serviceAdditionalSelected.valor))
            this.form
              .get('priceUnit')
              ?.setValue(convertCurrency(this.serviceAdditionalSelected.valor))
            this.form.get('amount')?.setValue(1)
            this.calculateTotal()
          }
        } else {
          this.serviceAdditionalSelected = {}
          this.form.get('serviceAdditional')?.setValue('')
          this.form.get('serviceAdditionalPrice')?.setValue('')
          this.form.get('amount')?.setValue(1)
          this.form.get('priceUnit')?.setValue('')
          this.form.get('priceTotal')?.setValue('')
        }
      }
    })
  }
}
